module.exports = __webpack_public_path__ + "img/beaver.5cb9937a.jpg";